import { useEffect, useState } from 'react';
import { profile, sections } from '../data/content';
import { useActiveSection } from '../hooks/useActiveSection';

const ids = sections.map((section) => section.id);

export function Nav() {
  const [stuck, setStuck] = useState(false);
  const [open, setOpen] = useState(false);
  const active = useActiveSection(ids);

  // The 2021 site kept the bar hidden over the hero and dropped it in after
  // 300px. Same threshold, same idea.
  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="nav" data-stuck={stuck} data-open={open}>
      <div className="container">
        <div className="nav__inner">
          <a className="nav__name" href="#top" onClick={() => setOpen(false)}>
            {profile.name}
          </a>

          <nav aria-label="Sections">
            <ul className="nav__list">
              {sections.map((section) => (
                <li key={section.id}>
                  <a
                    className="nav__link"
                    href={`#${section.id}`}
                    aria-current={active === section.id}
                  >
                    {section.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <button
            type="button"
            className="nav__toggle"
            aria-expanded={open}
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((value) => !value)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* inert rather than hidden so the max-height transition still runs. */}
        <div className="nav__drawer" inert={!open}>
          {sections.map((section) => (
            <a key={section.id} href={`#${section.id}`} onClick={() => setOpen(false)}>
              {section.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}
